import { Box } from "@material-ui/core";
import { FC, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";

import CenteredMessage from "../../../components/CenteredMessage";
import { GenericObject } from "../../../types/generic.types";
import { BaseChatContext } from "../index";
import { markRoomAsSeenAction } from "../redux/actions";
import { syncRoomMessage } from "../redux/reducer/chat.reducer";
import { isReceiver } from "../utils";
import chatQueries from "../utils/chatQueries";
import Message from "./Message";

const Messages: FC<MessagesProps> = ({ messages, roomId }) => {
  const dispatch = useDispatch();

  const { userRef, userId } = useContext(BaseChatContext);

  const handleMarkRoomAsSeen = () => {
    if (userId && userRef) {
      if (messages.length > 0 && isReceiver(messages[0], userId)) {
        console.log("Marking room as seen...");
        dispatch(markRoomAsSeenAction({ roomId, userRef }));
      }
    }
  };

  useEffect(() => {
    handleMarkRoomAsSeen();

    return () => {
      handleMarkRoomAsSeen();
    };
  }, [roomId]);

  useEffect(() => {
    let unsubscribeToMessagesListener: any;

    if (userId) {
      unsubscribeToMessagesListener = chatQueries.getRoomMessages({ roomId, limit: 2 }).onSnapshot({
        next(snapshot) {
          if (!snapshot.empty) {
            const messageSnapshot = snapshot.docs[0];
            const message = {
              ...messageSnapshot.data(),
              id: messageSnapshot.id,
            };
            dispatch(syncRoomMessage({ roomId, message }));
          }
        },
        error(ex: any) {
          console.log(ex.message);
        },
      });
    }

    return () => {
      if (unsubscribeToMessagesListener) return unsubscribeToMessagesListener();
    };
  }, [roomId, userId]);

  return (
    <>
      {messages.length > 0 ? (
        <Box display="flex" flexDirection="column-reverse">
          {messages.map((message: GenericObject) => (
            <Message key={message.id} message={message} />
          ))}
        </Box>
      ) : (
        <CenteredMessage message="No messages yet!" />
      )}
    </>
  );
};

interface MessagesProps {
  messages: any;
  roomId: string;
  lastMessageSeen: boolean;
}

export default Messages;
